import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareUsers = data => {
  const results = data.results || data.result?.users || data || [];

  return results.map(item => {
    const user = item.user || item.creator || item;

    return {
      uuid: user.uuid,
      name: user.name
    };
  });
};

function* getLookbookUsers({ payload: { id, segment, page_size, signal, onSuccess } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.lookbooks.users,
      id,
      params: {
        segment,
        ...(page_size && { page_size })
      },
      signal
    });

    const preparedData = prepareUsers(data);

    onSuccess && onSuccess(preparedData);
    yield put(actions.getLookbookUsersDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getLookbookUsersFailed,
      endpoint: api.lookbooks.users.url
    });
  }
}

export const getLookbookUsersSaga = takeEvery(types.GET_LOOKBOOK_USERS_REQUEST, getLookbookUsers);
